import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addPractitionerButton: {
    id: 'calsync.practitioner-list.add-practitioner-button',
    defaultMessage: 'Add practitioner',
  },
  shareClassPassCalendar: {
    id: 'calsync.practitioner-list.share-classpass-calendar',
    defaultMessage: 'Share this ClassPass calendar',
  },
  save: {
    id: 'calsync.practitioner-list.save-calendar',
    defaultMessage: 'Save',
  },
  remove: {
    id: 'calsync.practitioner-list.remove-calendar',
    defaultMessage: 'Remove',
  },
  exportLinkTooltip: {
    id: 'calsync.practitioner-list.export-link-tooltip',
    defaultMessage:
      'Click this link to generate a URL for this practitioner/equipment which can be used to export your CP appointments to your calendar app',
  },
  venueExportLinkTooltip: {
    id: 'calsync.practitioner-list.venue-export-link-tooltip',
    defaultMessage:
      'Click this link to generate a URL for your venue which can be used to export all of your CP appointments to your calendar app',
  },
  importUrlTooltip: {
    id: 'calsync.practitioner-list.import-link-tooltip',
    defaultMessage: 'Provide a unique URL for your practitioner/equipment to import their external calendar',
  },
  invalidLink: {
    id: 'calsync.practitioner-list.invalid-link',
    defaultMessage:
      "It looks like you've entered a URL we're unable to reference for Calendar Sync. Your link should include terms like ical, webcal, export, api or ics. <a>Click here</a> to learn more.",
  },
  wrongPlatformError: {
    id: 'calsync.practitioner-list.wrong-platform-error',
    defaultMessage:
      'It looks like you’ve inputted your export URL from CP - please provide an import link from your external calendar application such as Apple calendar or your booking platform',
  },
  lastSuccessfulSync: {
    id: 'calsync.practitioner-list.last-successful-sync',
    defaultMessage: 'Last Sync: <bold>{syncDate, date, long-w-dow-time}</bold>',
  },
  addAvailability: {
    id: 'calsync.practitioner-list.add-availability',
    defaultMessage: 'Add availability to get started',
  },
  noWriteAccessToCalendar: {
    id: 'calsync.practitioner-list.google-flow.no-write-access-to-calendar',
    defaultMessage: 'You no longer have write access to this calendar',
  },
  googleCalendarPlaceholder: {
    id: 'calsync.practitioner-list.google-flow.dropdown-placeholder',
    defaultMessage: 'Select calendar to sync',
  },
  googleAuthError: {
    id: 'calsync.practitioner-list.google-flow.google-auth-error',
    defaultMessage:
      'Unable to connect to your Google account. <a>Contact us</a> to reset and restart your Calendar Sync. You can also reset manually by clicking the reset button.',
  },
  googleAuthReset: {
    id: 'calsync.practitioner-list.google-flow.google-auth-reset',
    defaultMessage: 'Reset',
  },
  iCalCalendarHelperText: {
    id: 'calsync.practitioner-list.ical-calendar-helper-text',
    defaultMessage: "Provide the unique URL for this practitioner's external calendar",
  },
  practitionerSave: {
    id: 'calsync.practitioner-list.practitioner-form.save',
    defaultMessage: 'Done',
  },
  staffAndEquipmentUpdated: {
    id: 'calsync.practitioner-list.staff-and-equipment-updated',
    defaultMessage: 'Staff or Equipment has been updated successfully',
  },
  editPractitionerLink: {
    id: 'calsync.practitioner-list.edit-practitioner',
    defaultMessage: 'Edit more details for {name}',
  },
});
